import React, {Component} from 'react';
import {convertFromRaw, convertToRaw, EditorState} from 'draft-js';
import DraftEditor from 'draft-js-plugins-editor';
import createToolbarPlugin, {Separator} from 'draft-js-static-toolbar-plugin';
import createEmojiPlugin from 'draft-js-emoji-plugin';
import createImagePlugin from 'draft-js-image-plugin';
import editorStyles from './Editor.module.scss';
import {
  BoldButton, ItalicButton, OrderedListButton, UnderlineButton, UnorderedListButton,
} from 'draft-js-buttons';
import {Field} from "formik";
import HeadlinesButton from "./HeadlinesButton";
import ImageButton from "./ImageButton";
import _ from 'lodash';

const emojiPlugin = createEmojiPlugin();
const toolbarPlugin = createToolbarPlugin();

const {Toolbar} = toolbarPlugin;
const {EmojiSuggestions, EmojiSelect} = emojiPlugin;

const imagePlugin = createImagePlugin();

const plugins = [toolbarPlugin, emojiPlugin, imagePlugin];

const MAX_LENGTH = 10000;

const isEditorStateEmpty = (editorContent) => {
  const rawState = convertToRaw(editorContent);
  if (!rawState || _.isEmpty(rawState)) {
    return true;
  }
  const contentState = convertFromRaw(rawState);

  return !(contentState.hasText() && (contentState.getPlainText().trim() !== ''));
};

export default class Editor extends Component {

  state = {
    editorState: EditorState.createEmpty(), editor: false
  };

  componentDidMount() {
    let state = {
      editor: true
    };
    if (this.props.value) {
      state.editorState = EditorState.createWithContent(convertFromRaw(this.props.value));
    }
    this.setState(state);
  };

  onChange = (setFieldValue) => {
    return (editorState) => {
      this.setState({
        editorState,
      });

      if (editorState && !isEditorStateEmpty(editorState.getCurrentContent())) {
        setFieldValue(this.props.editorName, convertToRaw(editorState.getCurrentContent()));
      } else {
        setFieldValue(this.props.editorName, null);
      }
    };
  };

  getLengthOfSelectedText = () => {
    const currentSelection = this.state.editorState.getSelection();
    const isCollapsed = currentSelection.isCollapsed();

    let length = 0;

    if (!isCollapsed) {
      const currentContent = this.state.editorState.getCurrentContent();
      const startKey = currentSelection.getStartKey();
      const endKey = currentSelection.getEndKey();
      const startBlock = currentContent.getBlockForKey(startKey);
      const isStartAndEndBlockAreTheSame = startKey === endKey;
      const startBlockTextLength = startBlock.getLength();
      const startSelectedTextLength = startBlockTextLength - currentSelection.getStartOffset();
      const endSelectedTextLength = currentSelection.getEndOffset();
      const keyAfterEnd = currentContent.getKeyAfter(endKey);
      if (isStartAndEndBlockAreTheSame) {
        length += currentSelection.getEndOffset() - currentSelection.getStartOffset();
      } else {
        let currentKey = startKey;

        while (currentKey && currentKey !== keyAfterEnd) {
          if (currentKey === startKey) {
            length += startSelectedTextLength + 1;
          } else if (currentKey === endKey) {
            length += endSelectedTextLength;
          } else {
            length += currentContent.getBlockForKey(currentKey).getLength() + 1;
          }
          currentKey = currentContent.getKeyAfter(currentKey);
        }
      }
    }

    return length;
  };

  handleBeforeInput = () => {
    const currentContent = this.state.editorState.getCurrentContent();
    const currentContentLength = currentContent.getPlainText('').length;
    const selectedTextLength = this.getLengthOfSelectedText();

    if (currentContentLength - selectedTextLength > MAX_LENGTH - 1) {
      return 'handled';
    }
  };

  handlePastedText = (pastedText) => {
    const currentContent = this.state.editorState.getCurrentContent();
    const currentContentLength = currentContent.getPlainText('').length;
    const selectedTextLength = this.getLengthOfSelectedText();

    if (currentContentLength + pastedText.length - selectedTextLength > MAX_LENGTH) {
      return 'handled';
    }
  };

  focus = () => {
    this.editor.focus();
  };

  render() {
    const {editor} = this.state;
    const self = this;
    return (<React.Fragment>


      {editor && (<Field name={this.props.editorName} id={this.props.editorId}>
        {({field: {value}, form: {setFieldValue}}) => (<div className={editorStyles.editor_wrapper}>

          <label htmlFor={this.props.editorId} className={editorStyles.label}>
            {this.props.editorLabel}
          </label>

          <div className={editorStyles.editor} onClick={this.focus} ref={this.props.anchorRef}>
            <DraftEditor
              onChange={this.onChange(setFieldValue).bind(this)}
              editorState={this.state.editorState}
              plugins={plugins}
              placeholder={this.props.editorPlaceholder}
              handleBeforeInput={this.handleBeforeInput}
              handlePastedText={this.handlePastedText}
              ref={(element) => {
                this.editor = element;
              }}/>
            <EmojiSuggestions/>
            <Toolbar>
              {(externalProps) => {
                return (<React.Fragment>
                  <BoldButton {...externalProps} />
                  <ItalicButton {...externalProps} />
                  <UnderlineButton {...externalProps} />
                  <Separator {...externalProps} />
                  <UnorderedListButton {...externalProps} />
                  <OrderedListButton {...externalProps} />
                  <HeadlinesButton {...externalProps} />
                  <Separator {...externalProps} />
                  <EmojiSelect/>
                  <Separator {...externalProps} />
                  <ImageButton {...externalProps}
                               id={`img_btn_${self.props.editorId}`}
                               imageUploadUrl={self.props.editorImageUploadUrl}
                               editorState={self.state.editorState}
                               onChange={self.onChange(setFieldValue)}
                               modifier={imagePlugin.addImage}/>
                </React.Fragment>);
              }}
            </Toolbar>
          </div>
        </div>)}</Field>)}
    </React.Fragment>);
  }
}
